import { Button2, IonIcon } from '@valuecase/ui-components'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@valuecase/ui-components/src/components/ui/dialog'
import { useCallback } from 'react'
import GradientSpacesList from './GradientSpacesList'
import { ReadSpacesListDTO } from '@/modules/spaces/hooks/types'
interface ArchiveSpacesDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  selectedSpaces: ReadSpacesListDTO[]
  onArchive: () => void
  isLoading?: boolean
}

const ArchiveSpacesDialog = ({
  isOpen,
  onOpenChange,
  selectedSpaces,
  onArchive,
  isLoading,
}: ArchiveSpacesDialogProps) => {
  const handleArchiveConfirm = useCallback(async () => {
    onArchive()
  }, [onArchive])

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className='min-w-[580px]'>
        <DialogHeader className='flex items-center gap-2 bg-white border-none'>
          <IonIcon name='file-tray' className='w-10 h-10 text-blue-s4' />
          <DialogTitle>
            Archive {selectedSpaces.length === 1 ? 'Space' : `${selectedSpaces.length} Spaces`}
          </DialogTitle>
          <DialogDescription>
            This disables space access and stops active email notifications to customers. Do you
            want to proceed?
          </DialogDescription>
        </DialogHeader>
        <DialogBody className='bg-white border-none'>
          <GradientSpacesList spaces={selectedSpaces} />
        </DialogBody>
        <DialogFooter>
          <Button2
            className='w-full'
            variant='outlined'
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancel
          </Button2>
          <Button2
            className='w-full'
            leadingIcon='file-tray'
            variant='solid'
            onClick={handleArchiveConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Archiving...' : 'Archive'}
          </Button2>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ArchiveSpacesDialog
